module.exports = __webpack_public_path__ + "static/media/btn_registerda01f7c92091c5f401708e4268bd012d.webp";